<template>
    <div>
        <div ref="dropzone" class="dropzone"></div>

        <div class="alert alert-warning mt-3" v-if="uploading">
            Please wait until members will be imported. Do not close this tab.
        </div>

        <div class="alert alert-danger mt-3" v-if="errorMessage">
            {{ errorMessage }}
        </div>

        <div class="alert alert-success mt-3" v-if="successMessage">
            {{ successMessage }}
        </div>
    </div>
</template>

<script>
import Dropzone from 'dropzone';

export default {
    props: ['performer', 'url', 'redirect-to'],

    data() {
        return {
            dropzone: null,
            uploading: false,
            errorMessage: null,
            successMessage: null,
        };
    },

    mounted() {
        Dropzone.autoDiscover = false;
        this.dropzone = new Dropzone(this.$refs.dropzone, {
            headers: {
                'x-csrf-token': window.token,
            },
            url: this.url,
            paramName: "file",
            maxFilesize: 10, // 10 MB
            uploadMultiple: false,
            parallelUploads: 1,
            timeout: -1,
        });

        this.dropzone.on("error", (file, error) => {
            if (error.errors && error.errors.file) {
                file.previewElement.querySelectorAll('.dz-error-message span')[0].textContent = error.errors.file[0];
            } else if (error.message) {
                file.previewElement.querySelectorAll('.dz-error-message span')[0].textContent = error.message;
            }
        });

        this.dropzone.on('processing', () => {
            this.uploading = true;
        });

        this.dropzone.on('complete', () => {
            this.uploading = false;
        });

        if (this.redirectTo) {
            this.dropzone.on("queuecomplete", () => {
                // window.location.href = this.redirectTo;
            });
        }

        this.dropzone.on('addedfile', () => {
            this.errorMessage = null;
            this.successMessage = null;
        });

        this.dropzone.on('error', (file) => {
            this.errorMessage = JSON.parse(file.xhr.responseText).message;
        });

        this.dropzone.on('success', (file) => {
            this.successMessage = JSON.parse(file.xhr.responseText).message;
        });

        window.addEventListener('beforeunload', (event) => {
            if (this.uploading) {
                event.preventDefault();
                event.returnValue = '';
            }
        });
    }
}
</script>
